export default "__VITE_ASSET__mLmnFCzB__"